import styled from 'styled-components';

export const PostUploadWrapper = styled.section`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 12px;
  padding: 20px 16px 0;
`;
